import { createAction } from '../utils/createAction';
import {
  UPDATE_SO_DELIVERY_TIME,
} from './actionTypes';

// actions
export const updateSODeliveryTime = createAction(UPDATE_SO_DELIVERY_TIME, 'deliveryTime', 'productionLeadTime');
